import Swiper, {Pagination} from "swiper";
import {hideModal, isDesktop, isMobile, numberFormat, scale} from "../components/helpers";
import {ajaxAddToCart} from "../api/ajaxAddToCart";

export function initMainPageLanding() {
    if ($('#main_page_landing').length === 0) return;

    const $popularProductsSlider = $('#popular_products_slider');
    const $pagePreloader = $('#page_preloader');

    init();

    function init(){
        setPopularProductsHeight();
        initChooseCustomShirt();
        iniHandlers();
        initCatalogSlider();
        $pagePreloader.hide();
    }

    function initChooseCustomShirt() {
        //переключатель кастомных маек
        $('.shirt-switcher').on('click', e => {
            const $currentToggle = $(e.currentTarget);
            const imgSrc = $currentToggle.data('custom-shirt-toggle');
            const $image = $('[data-custom-shirt]');
            const $decoratePanel = $('.pretty-panel');
            const $homeSizes = $('[data-custom-shirt-sizes-1]');
            const $visitSizes = $('[data-custom-shirt-sizes-2]');
            const $productPrice = $('[data-product-price]');

            if (!$currentToggle.hasClass('active')) {
                $currentToggle.addClass('active');
                $currentToggle.siblings('.shirt-switcher').removeClass('active');
                $image.css('background-image', `url(${imgSrc})`);

                if ($decoratePanel.hasClass('left-position')) {
                    $decoratePanel.removeClass('left-position').addClass('right-position');
                    $decoratePanel.data('custom-shirt-type','visit');

                } else {
                    $decoratePanel.removeClass('right-position').addClass('left-position');
                    $decoratePanel.data('custom-shirt-type','home');
                }
            }

            if($decoratePanel.data('custom-shirt-type') === 'visit'){
                $homeSizes.addClass('hide');
                $visitSizes.removeClass('hide');
                initSizes(false);

            }else{
                $visitSizes.addClass('hide');
                $homeSizes.removeClass('hide');
                initSizes(true);
            }

            function initSizes(isHomeType){
                let $firstSize = $visitSizes.find('.switcher.custom-shirt-size:not(.disabled)').first();

                if(isHomeType){
                    $firstSize = $homeSizes.find('.switcher.custom-shirt-size:not(.disabled)').first();
                }

                let priceSize = +$firstSize.data('price');

                //если непустые инпуты или выбран чекбокс - плюсуем их сумму при переключении маек
                if($('#custom_shirt_family').val() !== ''){
                    const familyPrice = +$('#custom_shirt_family').siblings('[data-input-price]').data('input-price');
                    priceSize = priceSize + familyPrice;
                }

                if($('#custom_shirt_number').val() !== ''){
                    const numberPrice = +$('#custom_shirt_number').siblings('[data-input-price]').data('input-price');
                    priceSize = priceSize + numberPrice;
                }

                if($('#additional_options').prop('checked')){
                   const optionsPrice = +$('#additional_options_label').data('logo-price');
                   priceSize = priceSize + optionsPrice;
                }

                $productPrice.data('product-price', priceSize);
                $productPrice.text(`${numberFormat(priceSize, 0, '', ' ')} ₽`);

                $firstSize.siblings('.switcher.custom-shirt-size:not(.disabled)').removeClass('chosen');
                $firstSize.addClass('chosen');
            }
        });

        //раскрытие блока с логотипами в кастомной футболке
        $('.custom-shirt-logo-input').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const $currentTarget = $(e.target);

            if (!$currentTarget.hasClass('custom-shirts-checkboxes') && !$currentTarget.hasClass('custom-checkbox-label')) {
                $(this).toggleClass('opened');
            }
        });

        $('body').on('click', e => {
            const $currentTarget = $(e.target);

            if (!$currentTarget.hasClass('custom-shirts-checkboxes') || !$currentTarget.hasClass('custom-checkbox-label') || !$currentTarget.hasClass('custom-shirt-logo-input')) {
                $('.custom-shirt-logo-input').removeClass('opened');
            }
        });

    }


    function initPopularProductsSlider() {
       new Swiper('#popular_products_slider', {
            speed: 300,
            spaceBetween: 32,
            modules: [Pagination],
            pagination: {
                el: '.popular-slider-pagination',
                type: 'bullets',
                clickable: true
            },
            breakpoints: {
                620: {
                    spaceBetween: 20,
                    centeredSlides: false,
                    slidesPerView: 2,
                },
                1000: {
                    spaceBetween: 32,
                    slidesPerView: "auto",
                },
            }
        });
    }

    //максимальная высота для блока Популярные товары (чтобы блок с выбором кастомной майки не прыгал)
    function setPopularProductsHeight() {
        if(isDesktop()){
            let maxPopularProductsHeight = 0;

            $popularProductsSlider.find('.product-card').each(function () {
                const productHeight = $(this).get(0).scrollHeight;
                const bottomProductHeight =
                    (+$(this).find('.display-flex.flex-direction-column').outerHeight() || 0) + +$(this).find('.button.theme-secondary').outerHeight();

                const currentMaxHeight = productHeight + bottomProductHeight;

                if (currentMaxHeight > maxPopularProductsHeight) {
                    maxPopularProductsHeight = currentMaxHeight;
                }

            });

            $popularProductsSlider.css('height', `${maxPopularProductsHeight}px`);

        }else{
            $popularProductsSlider.css('height', 'auto');
        }

        initPopularProductsSlider()
    }

    function iniHandlers() {
        //раскрытие/сворачивание популярного товара
        $('.product-card')
            .on('mouseenter', e => {
                const $currentPopularProduct = $(e.currentTarget);
                const $currentPopularProductBottom = $currentPopularProduct.find('.popular-bottom');
                const bottomHeight = $currentPopularProductBottom.get(0).scrollHeight;

                $currentPopularProductBottom.css('max-height', `${bottomHeight}px`);

            })
            .on('mouseleave', e => {
                const $currentPopularProduct = $(e.currentTarget);
                const $currentPopularProductBottom = $currentPopularProduct.find('.popular-bottom');

                $currentPopularProductBottom.css('max-height', 0);
            });


        //при ресайзе - пересчитываем высоту блока с популярными товарами
        $(window).on('resize', () => {
           setPopularProductsHeight();
        });

        //добавить в корзину поп товар
        $('[data-add-to-cart]').on('click', e => {
            e.preventDefault();

            const $clickedBtn = $(e.currentTarget);
            const $productBlock = $clickedBtn.parents('.product-card');
            const $chosenSize = $productBlock.find('.switcher.size.chosen');
            const chosenSizeId = $chosenSize.data('size');
            const chosenSizeValue = $chosenSize.text();
            const productId = +$chosenSize.data('id');
            let chosenSizePrice = $chosenSize.data('price');

            //если с акцией
            if($productBlock.hasClass('sale')){
                chosenSizePrice = $chosenSize.data('saleprice');
            }

            if($productBlock.find('.switcher').length && !$chosenSize.length ){
                $productBlock.find('[data-no-sizes-chosen]').css('opacity', 1);

            }else{
                const PRODUCT_INFO = {...JSON.parse(JSON.stringify($productBlock.data('product-info')))}
                PRODUCT_INFO.chosenSizeId = chosenSizeId;
                PRODUCT_INFO.chosenSizeText = chosenSizeValue;
                PRODUCT_INFO.price = chosenSizePrice;
                PRODUCT_INFO.id = productId;

                addToCart(PRODUCT_INFO, 'popular');
            }
        });

        //добавить в корзину кастомную майку
        $('[data-add-to-cart-custom-shirt]').on('click', () => {
            const isOptionsChecked = $('#additional_options').prop('checked');
            let errors = 0;

            //если чекбокс опций чекнут - проверяем заполняемость инпутов
            if(isOptionsChecked){
                if($('#custom_shirt_family').val() === ''){
                    $('[data-no-logo-chosen-fio]').css('display', 'block');
                    errors++;
                }

                if($('#custom_shirt_number').val() === ''){
                    $('[data-no-logo-chosen-number]').css('display', 'block');
                    errors++;
                }

                if(errors > 0){
                    return;
                }
            }

            const $customShirtBlock = $('.custom-shirt');
            const $customShirtChosenSize = $('#custom_shirt_block').find('.switcher.custom-shirt-size.chosen');
            const productId = +$customShirtChosenSize.data('id');

            if(!$customShirtChosenSize.length){
                $customShirtBlock.find('[data-no-sizes-chosen]').css('opacity', 1);

            }else{
                const PRODUCT_INFO = {...JSON.parse(JSON.stringify($customShirtBlock.data('product-info')))};
                PRODUCT_INFO.chosenSize = $customShirtChosenSize.text();
                PRODUCT_INFO.chosenSizeId = $customShirtChosenSize.data('size');
                PRODUCT_INFO.id = productId;

                if($('.pretty-panel').hasClass('right-position')){
                    const $visitSizes = $('[data-custom-shirt-sizes-2]');
                    const $chozenSize = $visitSizes.find('.switcher.custom-shirt-size.chosen');
                    const productId = +$chozenSize.data('id');
                    const sizeText = $chozenSize.text();
                    const sizeId = $chozenSize.data('size');

                    PRODUCT_INFO.chosenSize = sizeText;
                    PRODUCT_INFO.chosenSizeId = sizeId;
                    PRODUCT_INFO.id = productId;

                }else if($('.pretty-panel').hasClass('left-position')){
                    const $homeSizes = $('[data-custom-shirt-sizes-1]');
                    const $chozenSize = $homeSizes.find('.switcher.custom-shirt-size.chosen');
                    const productId = +$chozenSize.data('id');
                    const sizeText = $chozenSize.text();
                    const sizeId = $chozenSize.data('size');

                    PRODUCT_INFO.chosenSize = sizeText;
                    PRODUCT_INFO.chosenSizeId = sizeId;
                    PRODUCT_INFO.id = productId;
                }

                addToCart(PRODUCT_INFO,'customShirt');
            }
        });

        //закрытие модалки
        $('[data-close-cart-modal]').on('click', e => {
            const $clickedModalClose = $(e.currentTarget);

            hideModal($clickedModalClose);
        });

    }

    function initCatalogSlider(){
        new Swiper('#shop_swiper', {
            slidesPerView: "auto",
            spaceBetween: 17,
            breakpoints: {
                760: {
                    spaceBetween: 32,
                },
                1000: {
                    spaceBetween: 24,
                },
                1281: {
                    spaceBetween: 32,
                },
            }
        });
    }

    function addToCart(PRODUCT_INFO, productType) {
        let productData = {};

        //если продукт - кастомная майка, раскрыта Доп панель и данные внутри этой панели не пустые - добавляем в запрос
        if (productType === 'customShirt') {
            const familyVal = $('#custom_shirt_family').val();
            const numberVal = $('#custom_shirt_number').val();
            const $chosenLogos = $('[data-checkboxes]').find('.custom-checkbox-label.checked');
            const img = $('.custom-shirt-image').css('background-image');
            const customShirtType = $('.pretty-panel').hasClass('left-position') ? 'home' : 'visit';
            let chosenLogosValue = [];

            if ($chosenLogos.length !== 0) {
                $chosenLogos.each((_, logo) => {
                    chosenLogosValue.push(
                        {
                            logoId: $(logo).data('logo-id'),
                            logoName: $(logo).data('logo-name')
                        }
                    )
                });
            }

            productData = {
                itemId: +PRODUCT_INFO.id,
                price: PRODUCT_INFO.price,
                type: PRODUCT_INFO.type,
                size: PRODUCT_INFO.chosenSizeId,
                count: 1,
                sizeText: PRODUCT_INFO.chosenSize,
                name: PRODUCT_INFO.name,
                img,
                customShirtLastName: familyVal,
                customShirtNumber: numberVal,
                customShirtLogos: chosenLogosValue,
                customShirtType
            }

        } else {
            productData = {
                itemId: +PRODUCT_INFO.id,
                price: PRODUCT_INFO.price,
                type: PRODUCT_INFO.type,
                size: PRODUCT_INFO.chosenSizeId,
                count: 1,
                sizeText: PRODUCT_INFO.chosenSizeText,
                name: PRODUCT_INFO.name,
                img: PRODUCT_INFO.img
            }

        }

        ajaxAddToCart(productData,productType);
    }
}